import React, { FC } from 'react';
import {
  TableOfContentChildDetails,
  TableOfContentsChapter,
} from 'src/store/table-of-contents/types';
import { Typography } from '@material-ui/core';
import {
  AccordionItemContent,
  StyledTypography,
  AccordionSummaryContent,
} from './SubChapterTrajectoryItemStyed';

export const TrajectoryAccordionItem: FC<{
  item: TableOfContentChildDetails;
  type: 'subchapter' | 'trajectory' | 'child-trajectory';
  parent?: TableOfContentsChapter;
}> = ({ item, type, parent }) => {
  return (
    <AccordionItemContent type={type} id={item.id}>
      <AccordionSummaryContent>
        <div
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}
        >
          <StyledTypography
            variant="subtitle2"
            sample={item.isSampleTrajectory ? 'isSample' : null}
            type={type}
            sampleColor={parent?.color}
            draft={item.isDraft}
          >
            {item.number}
          </StyledTypography>
          <StyledTypography
            sample={item.isSampleTrajectory ? 'isSample' : null}
            type={type}
            sampleColor={parent?.color}
            draft={item.isDraft}
          >
            {item.title}
          </StyledTypography>
        </div>
        {item.isLastOpenedTrajectory && (
          <Typography variant="subtitle1" component={'p'}>
            LAATST GEOPEND
          </Typography>
        )}
      </AccordionSummaryContent>
    </AccordionItemContent>
  );
};
